import { Text } from '@ui/atoms';
import { cn } from '@ui/atoms/utils/utils';
import React from 'react';

const ClosedTag = ({ isFullyRepaid, className }) => {
    return (
        <div
            className={cn(
                'px-3 py-1 rounded-tl-lg rounded-br-lg bg-yellow-gradient flex items-center justify-center w-fit relative shadow-lg',
                className,
                {
                    'bg-tbills-closed': isFullyRepaid,
                }
            )}
        >
            <Text
                content={isFullyRepaid ? 'Fully repaid on time' : '100% Subscribed'}
                className={cn('text-basicBlack p7-semibold',
                    {'text-basicWhite': isFullyRepaid}
                )}
            />
        </div>
    );
};

export default ClosedTag;
